import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALE_OPTIONS, DEFAULT_LOCALE } from '../i18n/constants';
import { Flag } from './ui/Flags';
import './LanguageSelector.css';
const LanguageSelector = () => {
    const { i18n, t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const selectorRef = useRef(null);
    const currentLangCode = (i18n.language || '').split(/[-_]/)[0]?.toLowerCase();
    const currentLanguage = LOCALE_OPTIONS.find((lang) => lang.code === currentLangCode) ??
        LOCALE_OPTIONS.find((lang) => lang.code === DEFAULT_LOCALE) ??
        LOCALE_OPTIONS[0];
    const handleLanguageChange = (languageCode) => {
        i18n.changeLanguage(languageCode);
        setIsOpen(false);
    };
    // Schließen bei Klick außerhalb oder Escape
    useEffect(() => {
        if (!isOpen)
            return;
        const handleClickOutside = (event) => {
            if (selectorRef.current && !selectorRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        const handleKey = (event) => {
            if (event.key === 'Escape')
                setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside);
        document.addEventListener('keydown', handleKey);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
            document.removeEventListener('keydown', handleKey);
        };
    }, [isOpen]);
    return (_jsxs("div", { className: "language-selector", ref: selectorRef, children: [_jsxs("button", { type: "button", className: "icon-btn current-language", onClick: () => setIsOpen(!isOpen), "aria-expanded": isOpen, "aria-haspopup": "listbox", "aria-label": `${t('navigation.language', 'Language')}: ${currentLanguage.name}`, children: [_jsx(Flag, { code: currentLanguage.code, size: 22 }), _jsx("span", { className: "current-language-code", children: currentLanguage.code.toUpperCase() })] }), isOpen && (_jsx("ul", { className: "language-dropdown", role: "listbox", "aria-label": t('navigation.language', 'Language'), children: LOCALE_OPTIONS.map((language) => (_jsx("li", { children: _jsxs("button", { type: "button", role: "option", "aria-selected": currentLangCode === language.code, lang: language.code, className: `language-option ${currentLangCode === language.code ? 'active' : ''}`, onClick: () => handleLanguageChange(language.code), children: [_jsx(Flag, { code: language.code, size: 24 }), _jsx("span", { className: "language-code", children: language.code.toUpperCase() }), _jsx("span", { className: "language-name", children: language.name })] }) }, language.code))) }))] }));
};
export default LanguageSelector;
